import React from 'react';
import {Link} from 'react-router-dom';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">

      <svg aria-hidden="true" style={{position: "absolute", width: 0, height: 0, overflow: "hidden"}} version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
      <symbol id="icon-arrow-left" viewBox="0 0 43 32">
      <title>arrow-left</title>
      <path d="M42.942 15.013h-39.575l13.605-13.62c0.015-0.046-1.377-1.393-1.377-1.393l-15.304 15.304c0 0.015-0.015 0.015-0.031 0.031l-0.061 0.061c-0.015 0.015-0.031 0.031-0.031 0.046-0.015 0.015-0.031 0.046-0.046 0.077-0.015 0.015-0.015 0.046-0.031 0.061 0 0.015-0.015 0.031-0.015 0.046v0.031c-0.015 0.015-0.015 0.046-0.015 0.061 0 0.031-0.015 0.046-0.015 0.077 0 0.015 0 0.046-0.015 0.061 0 0.031 0 0.046-0.015 0.077v0.153c0 0.031 0 0.046 0.015 0.077 0 0.015 0 0.046 0.015 0.061 0 0.031 0.015 0.046 0.015 0.077 0 0.015 0.015 0.046 0.015 0.061s0 0.015 0.015 0.031c0 0.015 0.015 0.031 0.031 0.046s0.015 0.046 0.031 0.061c0.015 0.031 0.031 0.046 0.046 0.077 0.015 0.015 0.031 0.031 0.031 0.046 0.015 0.015 0.031 0.046 0.061 0.061l15.334 15.334c0 0.015 1.393-1.393 1.393-1.393l-13.651-13.636h39.575v-1.974z"></path>
      </symbol>
      <symbol id="icon-arrow-right" viewBox="0 0 43 32">
      <title>arrow-right</title>
      <path d="M0 16.987h39.575l-13.605 13.62c0 0.061 1.393 1.408 1.393 1.393l15.304-15.304c0-0.015 0.015-0.015 0.031-0.031l0.061-0.061c0.015-0.015 0.031-0.031 0.031-0.046 0.015-0.015 0.031-0.046 0.046-0.077 0.015-0.015 0.015-0.046 0.031-0.061 0-0.015 0.015-0.031 0.015-0.046v-0.031c0.015-0.015 0.015-0.046 0.015-0.061 0-0.031 0.015-0.046 0.015-0.077 0-0.015 0-0.046 0.015-0.061 0-0.031 0-0.046 0.015-0.077v-0.153c0-0.031 0-0.046-0.015-0.077 0-0.015 0-0.046-0.015-0.061 0-0.031-0.015-0.046-0.015-0.077 0-0.015-0.015-0.046-0.015-0.061s0-0.015-0.015-0.031c0-0.015-0.015-0.031-0.031-0.046s-0.015-0.046-0.031-0.061c-0.015-0.031-0.031-0.046-0.046-0.077-0.015-0.015-0.031-0.031-0.031-0.046-0.015-0.015-0.031-0.046-0.061-0.061 0.015 0 0-0.015 0-0.015l-15.304-15.304c0-0.015-1.393 1.393-1.393 1.393l13.605 13.62h-39.575v1.974z"></path>
      </symbol>
      <symbol id="icon-moon" viewBox="0 0 32 32">
      <title>moon</title>
      <path d="M16.166 32c-8.912 0-16.166-7.254-16.166-16.166 0-7.585 5.385-14.242 12.804-15.812 0.365-0.077 0.741 0.033 1.006 0.299s0.376 0.641 0.31 0.995c-0.177 0.896-0.265 1.802-0.265 2.676 0 7.696 6.258 13.954 13.954 13.954 0.962 0 1.935-0.1 2.897-0.31 0.365-0.077 0.741 0.033 1.006 0.299s0.376 0.63 0.31 0.995c-1.471 7.574-8.138 13.070-15.856 13.070zM11.71 2.61c-5.595 1.891-9.498 7.22-9.498 13.225 0 7.696 6.258 13.954 13.954 13.954 6.115 0 11.478-4.003 13.291-9.708-0.553 0.055-1.095 0.088-1.648 0.088-8.912 0-16.166-7.254-16.166-16.166 0-0.464 0.022-0.929 0.066-1.393z"></path>
      </symbol>
      <symbol id="icon-compass" viewBox="0 0 32 32">
      <title>compass</title>
      <path d="M15.994 32c-8.821 0-15.994-7.185-15.994-16.006s7.173-15.994 15.994-15.994c8.821 0 15.994 7.173 15.994 15.994s-7.173 16.006-15.994 16.006zM15.994 2.371c-7.505 0-13.623 6.118-13.623 13.623s6.118 13.623 13.623 13.623 13.623-6.118 13.623-13.623-6.106-13.623-13.623-13.623z"></path>
      <path d="M17.808 17.808l2.893-6.568-6.521 2.94-2.881 6.58 6.509-2.952z"></path>
      </symbol>
      <symbol id="icon-pip" viewBox="0 0 26 32">
      <title>pip</title>
      <path d="M13.182 32.011c-0.25-0.002-0.479-0.089-0.66-0.235l0.002 0.002c-1.284-1.061-12.524-10.178-12.524-18.595 0-7.28 5.902-13.182 13.182-13.182s13.182 5.902 13.182 13.182v0c0 8.576-12.28 18.584-12.842 18.765-0.101 0.040-0.217 0.063-0.339 0.064h-0zM13.182 2.123c-6.106 0.006-11.053 4.954-11.059 11.059v0.001c0 5.721 6.888 12.917 11.049 16.387 2.452-2.070 11.070-9.828 11.070-16.387-0.006-6.106-4.954-11.053-11.059-11.059h-0.001z"></path>
      <path d="M13.182 19.296c-3.382 0-6.124-2.742-6.124-6.124s2.742-6.124 6.124-6.124c3.382 0 6.124 2.742 6.124 6.124 0 0.004 0 0.007 0 0.011v-0.001c-0.006 3.378-2.746 6.113-6.124 6.113 0 0 0 0 0 0v0zM13.182 9.181c-2.21 0-4.001 1.791-4.001 4.001s1.791 4.001 4.001 4.001c2.21 0 4.001-1.791 4.001-4.001v0c0-2.21-1.791-4.001-4.001-4.001v0z"></path>
      </symbol>
      <symbol id="icon-sun" viewBox="0 0 32 32">
      <title>sun</title>
      <path d="M15.761 27.317c-6.244 0-11.321-5.077-11.321-11.321s5.077-11.321 11.321-11.321 11.321 5.077 11.321 11.321-5.077 11.321-11.321 11.321zM15.761 6.353c-5.321 0-9.643 4.33-9.643 9.643s4.33 9.643 9.643 9.643 9.643-4.33 9.643-9.643-4.322-9.643-9.643-9.643z"></path>
      <path d="M14.099 31.992v0 0c-0.579-0.059-0.999-0.571-0.94-1.15v0c0.059-0.579 0.579-0.999 1.15-0.94v0c0.579 0.059 0.999 0.579 0.94 1.15v0c-0.050 0.546-0.512 0.948-1.041 0.948v0c-0.034 0-0.076 0-0.109-0.008zM19.42 30.615c-0.176-0.546 0.117-1.141 0.671-1.318v0c0.554-0.185 1.141 0.117 1.326 0.671v0c0.176 0.554-0.126 1.141-0.671 1.318v0c-0.109 0.042-0.218 0.059-0.327 0.059v0c-0.445 0-0.856-0.285-0.999-0.73zM7.738 29.935c-0.504-0.285-0.671-0.932-0.386-1.435v0c0.294-0.504 0.932-0.671 1.435-0.386v0c0.504 0.294 0.671 0.932 0.386 1.435v0c-0.193 0.336-0.546 0.529-0.915 0.529v0c-0.176 0-0.352-0.050-0.52-0.143zM25.043 27.863c-0.386-0.428-0.352-1.091 0.076-1.477v0c0.436-0.386 1.099-0.352 1.485 0.076v0c0.386 0.428 0.352 1.091-0.076 1.485v0c-0.201 0.176-0.453 0.269-0.705 0.269v0c-0.285 0-0.571-0.117-0.78-0.352zM2.769 25.471c-0.344-0.47-0.243-1.125 0.227-1.469v0c0.47-0.336 1.125-0.235 1.469 0.235v0c0.336 0.462 0.235 1.125-0.227 1.46v0c-0.193 0.143-0.411 0.201-0.621 0.201v0c-0.327 0-0.646-0.143-0.848-0.428zM29.071 23.071c-0.529-0.235-0.764-0.856-0.529-1.385v0c0.235-0.529 0.848-0.772 1.385-0.537v0c0.529 0.243 0.764 0.856 0.529 1.385v0c-0.176 0.394-0.562 0.629-0.957 0.629v0c-0.143 0-0.294-0.034-0.428-0.092zM0.042 19.37c-0.126-0.562 0.235-1.125 0.806-1.242v0c0.562-0.117 1.116 0.235 1.242 0.806v0c0.118 0.562-0.243 1.125-0.806 1.242v0c-0.076 0.017-0.151 0.025-0.218 0.025v0c-0.487 0-0.923-0.336-1.024-0.831zM29.742 15.996v0 0c0-0.017 0-0.034 0-0.059v0c0-0.579 0.462-1.049 1.041-1.049v0c0.579 0 1.057 0.462 1.057 1.041v0c0 0.017 0 0.025 0 0.042v0c0 0.008 0 0.017 0 0.025v0 0 0c0 0.579-0.47 1.049-1.049 1.049v0c-0.579 0-1.049-0.47-1.049-1.049zM0.839 13.931c-0.571-0.117-0.932-0.671-0.814-1.242v0c0.117-0.571 0.671-0.932 1.242-0.814v0c0.562 0.117 0.932 0.68 0.806 1.242v0c-0.101 0.495-0.537 0.839-1.024 0.839v0c-0.067 0-0.143-0.008-0.21-0.025zM28.517 10.264c-0.243-0.529-0.008-1.15 0.52-1.385v0c0.529-0.243 1.15-0.008 1.393 0.52v0c0.235 0.529 0 1.15-0.529 1.393v0c-0.134 0.059-0.285 0.092-0.428 0.092v0c-0.403 0-0.789-0.235-0.957-0.621zM2.962 8.040c-0.47-0.336-0.571-0.99-0.235-1.46v0c0 0 0 0 0.008 0v0c0.336-0.47 0.99-0.579 1.46-0.235v0c0.47 0.344 0.571 0.999 0.235 1.469v0c-0.21 0.277-0.529 0.428-0.856 0.428v0c-0.21 0-0.42-0.067-0.613-0.201zM25.076 5.572c-0.428-0.386-0.462-1.049-0.076-1.477v0c0.386-0.428 1.049-0.47 1.477-0.084v0c0.428 0.386 0.47 1.049 0.084 1.485v0c-0.21 0.227-0.495 0.344-0.78 0.344v0c-0.252 0-0.504-0.084-0.705-0.269zM7.301 3.525c-0.285-0.495-0.117-1.141 0.378-1.427v0 0 0c0.504-0.294 1.15-0.126 1.435 0.378v0c0.294 0.495 0.126 1.141-0.378 1.435v0c-0.168 0.092-0.344 0.143-0.529 0.143v0c-0.361 0-0.705-0.193-0.906-0.529zM20.041 2.686c-0.554-0.176-0.856-0.772-0.68-1.318v0c0.176-0.554 0.764-0.856 1.318-0.68v0c0.554 0.176 0.856 0.764 0.68 1.318v0c-0.143 0.445-0.554 0.73-0.999 0.73v0c-0.109 0-0.21-0.017-0.319-0.050zM13.1 1.167c-0.059-0.579 0.361-1.091 0.932-1.158v0c0.579-0.059 1.091 0.361 1.158 0.932v0c0.059 0.579-0.361 1.099-0.932 1.158v0c-0.042 0-0.076 0.008-0.117 0.008v0c-0.529 0-0.982-0.403-1.041-0.94z"></path>
      </symbol>
      <symbol id="icon-wind" viewBox="0 0 36 32">
      <title>wind</title>
      <path d="M28.282 12.669v-0.011h-4.765c0.872-1.319 1.363-2.867 1.363-4.503 0-4.503-3.663-8.155-8.155-8.155s-8.155 3.663-8.155 8.155h2.181c0-3.293 2.682-5.975 5.975-5.975s5.975 2.682 5.975 5.975c0 1.734-0.752 3.358-2.061 4.503h-20.639v2.181h27.966c3.293 0 5.975 2.682 5.975 5.975s-2.682 5.975-5.975 5.975-5.975-2.682-5.975-5.975h-2.181c0 4.492 3.663 8.155 8.155 8.155s8.155-3.663 8.155-8.155c0-4.394-3.489-7.97-7.839-8.144z"></path>
      <path d="M11.11 15.722v-0.033h-11.11v2.181h10.412c3.293 0 5.975 2.682 5.975 5.975s-2.682 5.975-5.975 5.975-5.975-2.682-5.975-5.975h-2.181c0 4.492 3.663 8.155 8.155 8.155s8.155-3.663 8.155-8.155c0-4.274-3.282-7.774-7.458-8.123z"></path>
      </symbol>
      <symbol id="icon-facebook" viewBox="0 0 24 28">
      <title>instagram</title>
      <path d="M16 14c0-2.203-1.797-4-4-4s-4 1.797-4 4 1.797 4 4 4 4-1.797 4-4zM18.156 14c0 3.406-2.75 6.156-6.156 6.156s-6.156-2.75-6.156-6.156 2.75-6.156 6.156-6.156 6.156 2.75 6.156 6.156zM19.844 7.594c0 0.797-0.641 1.437-1.437 1.437s-1.437-0.641-1.437-1.437 0.641-1.437 1.437-1.437 1.437 0.641 1.437 1.437zM12 4.156c-1.75 0-5.5-0.141-7.078 0.484-0.547 0.219-0.953 0.484-1.375 0.906s-0.688 0.828-0.906 1.375c-0.625 1.578-0.484 5.328-0.484 7.078s-0.141 5.5 0.484 7.078c0.219 0.547 0.484 0.953 0.906 1.375s0.828 0.688 1.375 0.906c1.578 0.625 5.328 0.484 7.078 0.484s5.5 0.141 7.078-0.484c0.547-0.219 0.953-0.484 1.375-0.906s0.688-0.828 0.906-1.375c0.625-1.578 0.484-5.328 0.484-7.078s0.141-5.5-0.484-7.078c-0.219-0.547-0.484-0.953-0.906-1.375s-0.828-0.688-1.375-0.906c-1.578-0.625-5.328-0.484-7.078-0.484zM24 14c0 1.656 0.016 3.297-0.078 4.953-0.094 1.922-0.531 3.625-1.937 5.031s-3.109 1.844-5.031 1.937c-1.656 0.094-3.297 0.078-4.953 0.078s-3.297 0.016-4.953-0.078c-1.922-0.094-3.625-0.531-5.031-1.937s-1.844-3.109-1.937-5.031c-0.094-1.656-0.078-3.297-0.078-4.953s-0.016-3.297 0.078-4.953c0.094-1.922 0.531-3.625 1.937-5.031s3.109-1.844 5.031-1.937c1.656-0.094 3.297-0.078 4.953-0.078s3.297-0.016 4.953 0.078c1.922 0.094 3.625 0.531 5.031 1.937s1.844 3.109 1.937 5.031c0.094 1.656 0.078 3.297 0.078 4.953z"></path>
      </symbol>
      </defs>
      </svg>



      <div className="c-preloader | js-preloader">
      <div className="c-preloader__inner">
        <div className="c-preloader__circle | js-preloader__circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.97 30.92"><path d="M30.97 15.43c-2.51-.86-5.1-1.46-7.74-1.79-1-.13-2.06-.23-3.08-.3 0-.08.12-.15.17-.23 1.02-1.48 1.81-3.11 2.33-4.84-1.72.53-3.35 1.31-4.85 2.31-.08.05-.14.11-.21.16-.08-1-.18-2-.31-3A36.68 36.68 0 0 0 15.5 0c-.88 2.5-1.48 5.1-1.79 7.74-.13 1-.23 2.06-.31 3.09l-.25-.18a17.141 17.141 0 0 0-4.83-2.34c.52 1.71 1.3 3.34 2.31 4.82l.15.21c-1 .08-2 .17-3 .3-2.65.32-5.26.92-7.78 1.79 2.51.88 5.1 1.48 7.74 1.79 1 .13 2 .22 3.06.3-.06.08-.12.15-.17.23A17.504 17.504 0 0 0 8.3 22.6c1.73-.51 3.37-1.3 4.85-2.32l.25-.19c.08 1 .18 2.06.31 3.09.31 2.64.9 5.23 1.78 7.74.86-2.51 1.46-5.11 1.79-7.74.13-1 .23-2 .31-3 .07 0 .13.11.21.16 1.48 1.02 3.12 1.8 4.84 2.32-.51-1.73-1.29-3.37-2.32-4.85-.06-.08-.13-.16-.19-.25 1-.07 2.06-.17 3.1-.3 2.64-.33 5.23-.94 7.74-1.83z"></path></svg>
        </div>
      </div>
    </div>

    <header className="c-site-head c-site-head--normal o-gutter-s | js-site-head js-site-head--normal js-smooth-section">
      <figure className="c-site-head__logo | js-logo-link js-intro-item">
        <img src="/static/logo-white-horizontal.png" alt="" />
      </figure>
      <nav className="c-site-head__nav">
        <ul className="c-site-head-menu">

                  <li className="c-site-head-menu__item">
              <a
                href="/about"
                className="c-site-head-menu__link | js-site-link js-intro-item"

              >
                About
              </a>
            </li>
                  <li className="c-site-head-menu__item">
              <a
                href="/experiences"
                className="c-site-head-menu__link | js-site-link js-intro-item"

              >
                Experiences
              </a>
            </li>
                  <li className="c-site-head-menu__item">
              <Link
                to="/listings"
                className="c-site-head-menu__link | js-site-link js-intro-item"

              >
                Listings
              </Link>
            </li>
                  <li className="c-site-head-menu__item">
              <a
                href="/contact"
                className="c-site-head-menu__link | js-site-link js-intro-item"

              >
                Contact
              </a>
            </li>

        </ul>

        <button
          type="button"
          className="c-site-head__toggle | js-menu-toggle js-menu-toggle--normal"
          aria-label="Toggle menu"
        >
          <div className="c-burger">
            <div className="c-burger__line | js-burger__line"></div>
            <div className="c-burger__line | js-burger__line"></div>
            <div className="c-burger__line | js-burger__line"></div>

            <div className="c-burger-close">
              <div className="c-burger-close__line | js-burger-close__line--1"></div>
              <div className="c-burger-close__line | js-burger-close__line--2"></div>
            </div>
          </div>
        </button>

      </nav>
    </header>

    <div className="c-site-head-bg | js-site-head-bg"></div>
    <header className="c-site-head c-site-head--sticky o-gutter-s | js-site-head js-site-head--sticky" aria-hidden="true">
      <figure href="/" className="c-site-head__logo | js-logo-link js-site-head__logo" tab-index="-1">
        <img src="/static/logo-standing.png" alt="Chileno bay club" />
      </figure>
      <nav className="c-site-head__nav">
        <ul className="c-site-head-menu">

                  <li className="c-site-head-menu__item">
              <a
                href="/about"
                className="c-site-head-menu__link | js-site-link"
                tab-index="-1"

              >
                About
              </a>
            </li>
                  <li className="c-site-head-menu__item">
              <a
                href="/experiences"
                className="c-site-head-menu__link | js-site-link"
                tab-index="-1"

              >
                Experiences
              </a>
            </li>
                  <li className="c-site-head-menu__item">
              <Link
                to="/listings"
                className="c-site-head-menu__link | js-site-link"
                tab-index="-1"

              >
                Listings
              </Link>
            </li>
                  <li className="c-site-head-menu__item">
              <a
                href="/contact"
                className="c-site-head-menu__link | js-site-link"
                tab-index="-1"

              >
                Contact
              </a>
            </li>


        </ul>

        <button
          type="button"
          className="c-site-head__toggle | js-menu-toggle"
          tab-index="-1"
          aria-label="Toggle menu"
        >
          <div className="c-burger c-burger--dark">
            <div className="c-burger__line | js-burger__line"></div>
            <div className="c-burger__line | js-burger__line"></div>
            <div className="c-burger__line | js-burger__line"></div>

            <div className="c-burger-close">
              <div className="c-burger-close__line | js-burger-close__line--1"></div>
              <div className="c-burger-close__line | js-burger-close__line--2"></div>
            </div>
          </div>
        </button>

      </nav>
    </header>
    <nav className="c-mobile-nav | js-mobile-nav">
      <div className="c-mobile-nav__inner | js-mobile-nav__inner">
        <ul className="c-mobile-nav__menu">

                  <li className="c-mobile-nav__item">
              <a
                href="/about"
                className="o-gutter c-mobile-nav__link | js-site-link js-mobile-nav__link"
                data-transition="menu"

              >
                About
              </a>
            </li>
                  <li className="c-mobile-nav__item">
              <a
                href="/experiences"
                className="o-gutter c-mobile-nav__link | js-site-link js-mobile-nav__link"
                data-transition="menu"

              >
                Experiences
              </a>
            </li>
                  <li className="c-mobile-nav__item">
              <Link
                to="/listings"
                className="o-gutter c-mobile-nav__link | js-site-link js-mobile-nav__link"
                data-transition="menu"

              >
                Listings
              </Link>
            </li>
                  <li className="c-mobile-nav__item">
              <a
                href="/contact"
                className="o-gutter c-mobile-nav__link | js-site-link js-mobile-nav__link"
                data-transition="menu"

              >
                Contact
              </a>
            </li>

        </ul>
      </div>
    </nav>
    <main
      data-lat="41.834259"
      data-lng="-73.571259"
      className="o-page | js-smooth js-main"
      data-router-wrapper
    >
        <article data-router-view="home">
        <div className="o-page__mask | js-page__mask">



    <div className="c-hero  o-gutter | js-smooth-section js-hero">
      <div className="c-hero__bg o-cover o-cover--abs">


          <video
            src="https://dp92u1r0kzfby.cloudfront.net/ham.mp4"
            loop muted autoPlay playsInline preload="metadata"
            style={{backgroundImage: "url(" + 'https://dp92u1r0kzfby.cloudfront.net/falls.jpg' + ")"}}/>
          "cat"

      </div>
      <h1
        className="o-h1 c-hero__title | js-transition-line"
      >
        Welcome <em className="small-text">to</em> <br/> Ancaster <em className="small-text">and</em> Hamilton
      </h1>
      <div className="c-hero__cta">

              <h2 className="c-hero__sub-title | js-intro-item">By Michael Russo Homes</h2>

              <span className="js-intro-item">Scroll down</span>
          </div>


    </div>      <div className="c-intro o-gutter">
      <div className="o-row o-row--small">
        <p className="c-intro__text o-h3 | js-smooth-section" data-scroll="staggerLines">
        Located halfway between Toronto and Niagara, the quant, scenic area of Ancaster offers intense natural beauty while radiating charm. Michael Russo has been working for over 30 years in serving this area.
        </p>
      </div>
    </div>    </div>


    <div className="c-img-txt-2 c-img-txt-2--block c-img-txt-2--reverse o-gutter o-padding-bottom-s u-bg-white | js-smooth-section">
      <div className="o-row">
        <div className="c-img-txt-2__grid">

          <div className="c-img-txt-2__content c-content c-content--max@sm">


            <div className="c-content__text o-txt" data-scroll="staggerLinesP">
              <p>Ancaster is an affluent community  situated just West of Hamilton off of highway 403. When compared  with Burlington, Oakville and Toronto this area offers exceptional housing affordability.</p>
            </div>



          <a href="https://ancasterhamiltonhomes.com/about" className="c-btn c-btn--margin">
          <div className="c-btn__borders">
          <span className="c-btn__border c-btn__border--top"></span>
          <span className="c-btn__border c-btn__border--bottom"></span>
          <span className="c-btn__border c-btn__border--left"></span>
          <span className="c-btn__border c-btn__border--right"></span>
        </div>
        <div className="c-btn__text c-btn__text--top">Explore</div>
        <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Explore</div>
      </a>

          </div>

          <div className="c-img-txt-2__img c-img-txt-2__img--1">
            <figure
              className="o-cover o-cover--rel | js-parallax"
              data-from='{"yPercent": "0"}'
              data-to='{"yPercent": "15"}'
            >


                <div className="c-img-txt-2__gradient o-gradient-img">
                  <div className="o-gradient-img__inner" style={{backgroundImage: "url(" + '/imager/images/1248/lifestyle_thumb_a6d5da221c5021abd741e6da07ad9aaa.jpg' + ")"}}></div>
                </div>

              <img src="https://dp92u1r0kzfby.cloudfront.net/ancaster_forest_two.jpg" alt="" data-scroll="scaleIn" />
            </figure>
          </div>

          <div className="c-img-txt-2__img c-img-txt-2__img--2">
            <figure className="o-cover o-cover--rel">
              <img src="https://dp92u1r0kzfby.cloudfront.net/gate.jpg" alt="" data-scroll="scaleIn" />
            </figure>
          </div>

        </div>
      </div>
    </div>
    <div className="c-img c-img--full o-margin-bottom-s | js-smooth-section">
      <div className="c-img__inner">
        <figure className="c-img__img o-cover o-cover--abs">
          <div
            style={{backgroundImage: "url(" + 'https://dp92u1r0kzfby.cloudfront.net/ancaster_full.jpeg' + ")"}}
            className="o-cover--bg | js-parallax"
                      data-from='{"scale": "1"}'
              data-to='{"scale": "1.25"}'>
            </div>
        </figure>
      </div>
    </div>
    <div className="
      c-img-txt
      c-img-txt--gradient
      c-img-txt--normal
      o-gutter o-padding-bottom-s u-bg-white | js-smooth-section">
      <div className="o-row">
        <div className="c-img-txt__inner">
          <div className="c-img-txt__content c-content o-content-max">

                      <h3 className="o-h3 c-content__title" data-scroll="staggerWords">At your service...33 years and counting.</h3>

            <div className="o-txt" data-scroll="staggerLinesP">
              <p>Michael Russo is a realtor with over 30 years of experience. He has lead Ancaster <em className="small-text">and</em> Hamilton in promoting realtors and forming communities. As a leader in the region, he will happily help you pick your next community and home to live in.</p>
            </div>



          <a href="https://ancasterhamiltonhomes.com/about" className="c-btn c-btn--margin">
          <div className="c-btn__borders">
          <span className="c-btn__border c-btn__border--top"></span>
          <span className="c-btn__border c-btn__border--bottom"></span>
          <span className="c-btn__border c-btn__border--left"></span>
          <span className="c-btn__border c-btn__border--right"></span>
        </div>
        <div className="c-btn__text c-btn__text--top">Learn More</div>
        <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Learn More</div>
      </a>

          </div>
          <figure className="c-img-txt__img">
            <div className="c-img-txt__img-inner o-cover o-cover--abs">
              <img
                src="https://dp92u1r0kzfby.cloudfront.net/mike_two.png"
                alt=""
                data-scroll="scaleIn"
              />
            </div>


              <div className="c-img-txt__gradient o-gradient-img">
                <div className="o-gradient-img__inner" style={{backgroundImage: "url(" + '/imager/images/912/gold_lifes_carosuel_background-copy_aa93d8ee9a3cc573b9a01b328410e8b2.jpg' + ")"}}></div>
              </div>

          </figure>
        </div>
      </div>
    </div>
    <div className="c-slider-txt o-gutter-s o-margin-bottom-s | js-slider-txt js-smooth-section" data-autoplay="1">
      <div className="c-slider-txt__slider">
        <div className="c-slider-txt__slides | js-drag-area">


            <figure className="c-slider-txt__slide o-cover | js-drag-item" style={{left: "0%"}}>
              <img src="https://dp92u1r0kzfby.cloudfront.net/hamilton_dt.jpg" alt="" draggable="false" />
            </figure>

            <figure className="c-slider-txt__slide o-cover | js-drag-item" style={{left: "100%"}}>
              <img src="https://dp92u1r0kzfby.cloudfront.net/falls_two.jpg" alt="" draggable="false" />
            </figure>

            <figure className="c-slider-txt__slide o-cover | js-drag-item" style={{left: "200%"}}>
              <img src="https://dp92u1r0kzfby.cloudfront.net/ham_sign.jpg" alt="" draggable="false" />
            </figure>

            <figure className="c-slider-txt__slide o-cover | js-drag-item" style={{left: "300%"}}>
              <img src="https://dp92u1r0kzfby.cloudfront.net/ancaster_forest_two.jpg" alt="" draggable="false" />
            </figure>

        </div>
        <div className="c-slider-txt__foot">
          <nav className="c-slider-nav c-slider-nav--left">
            <button type="button" className="c-slider-nav__btn c-slider-nav__btn--prev is-disabled | js-prev" aria-label="Previous">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.06 20.91"><path d="M28.06 9.81H2.2l8.89-8.9c.01-.03-.9-.91-.9-.91l-10 10c0 .01-.01.01-.02.02l-.04.04c-.01.01-.02.02-.02.03-.01.01-.02.03-.03.05-.01.01-.01.03-.02.04 0 .01-.01.02-.01.03v.02c-.01.01-.01.03-.01.04 0 .02-.01.03-.01.05 0 .01 0 .03-.01.04 0 .02 0 .03-.01.05v.1c0 .02 0 .03.01.05 0 .01 0 .03.01.04 0 .02.01.03.01.05 0 .01.01.03.01.04 0 .01 0 .01.01.02 0 .01.01.02.02.03.01.01.01.03.02.04.01.02.02.03.03.05.01.01.02.02.02.03.01.01.02.03.04.04l.02.02 10 10c0 .01.91-.91.91-.91L2.2 11.1h25.86V9.81z"/></svg>
            </button>
            <button type="button" className="c-slider-nav__btn c-slider-nav__btn--next | js-next" aria-label="Next">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.06 20.91"><path d="M0 11.1h25.86L16.97 20c0 .04.91.92.91.91l10-10c0-.01.01-.01.02-.02l.04-.04c.01-.01.02-.02.02-.03.01-.01.02-.03.03-.05.01-.01.01-.03.02-.04 0-.01.01-.02.01-.03v-.02c.01-.01.01-.03.01-.04 0-.02.01-.03.01-.05 0-.01 0-.03.01-.04 0-.02 0-.03.01-.05v-.05-.05c0-.02 0-.03-.01-.05 0-.01 0-.03-.01-.04 0-.02-.01-.03-.01-.05 0-.01-.01-.03-.01-.04 0-.01 0-.01-.01-.02 0-.01-.01-.02-.02-.03-.01-.01-.01-.03-.02-.04-.01-.02-.02-.03-.03-.05-.01-.01-.02-.02-.02-.03-.01-.01-.02-.03-.04-.04.01 0 0-.01 0-.01l-10-10c0-.01-.91.91-.91.91l8.89 8.9H0v1.29z"/></svg>
            </button>
          </nav>
          <div className="c-pips | js-pips">
                      <div className="c-pips-pip is-active | js-pip"></div>
                      <div className="c-pips-pip  | js-pip"></div>
                      <div className="c-pips-pip  | js-pip"></div>
                      <div className="c-pips-pip  | js-pip"></div>
                  </div>
        </div>
      </div>
      <div className="c-slider-txt__content c-content o-content-max">
        <h3 className="o-h4 c-content__title c-content__title--small " data-scroll="staggerWords">Listings</h3>

              <div className="o-txt" data-scroll="staggerLinesP">
            <p>Take a virtual stroll through our neighborhood and...</p>
          </div>



          <a href="https://ancasterhamiltonhomes.com/listings" className="c-btn c-btn--margin">
          <div className="c-btn__borders">
          <span className="c-btn__border c-btn__border--top"></span>
          <span className="c-btn__border c-btn__border--bottom"></span>
          <span className="c-btn__border c-btn__border--left"></span>
          <span className="c-btn__border c-btn__border--right"></span>
        </div>
        <div className="c-btn__text c-btn__text--top">View Listings</div>
        <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">View Listings</div>
      </a>

      </div>
    </div>
        <div className="js-smooth-section u-bg-white">

      <div className="c-home-lifestyle o-padding-s u-bg-grey | js-home-slider">
        <h3 className="c-home-lifestyle__mobile-title o-h3 u-txt-center u-uppercase o-margin-bottom-xs" aria-hidden="true">Explore Ancaster</h3>
        <div className="o-row">
          <div className="c-home-lifestyle__inner">

            <div className="c-home-lifestyle__top o-gutter o-margin-bottom-xs">
              <div className="c-pips c-pips--left | js-pips">
                              <div className="c-pips-pip is-active | js-pip"></div>
                              <div className="c-pips-pip  | js-pip"></div>
                              <div className="c-pips-pip  | js-pip"></div>
                              <div className="c-pips-pip  | js-pip"></div>
                          </div>
              <h2 className="c-home-lifestyle__title o-h2 u-txt-center">Michael Russo Homes Lifestyle</h2>
              <nav className="c-slider-nav c-slider-nav--right">
                <button type="button" className="c-slider-nav__btn c-slider-nav__btn--prev is-disabled | js-prev" aria-label="Previous">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.06 20.91"><path d="M28.06 9.81H2.2l8.89-8.9c.01-.03-.9-.91-.9-.91l-10 10c0 .01-.01.01-.02.02l-.04.04c-.01.01-.02.02-.02.03-.01.01-.02.03-.03.05-.01.01-.01.03-.02.04 0 .01-.01.02-.01.03v.02c-.01.01-.01.03-.01.04 0 .02-.01.03-.01.05 0 .01 0 .03-.01.04 0 .02 0 .03-.01.05v.1c0 .02 0 .03.01.05 0 .01 0 .03.01.04 0 .02.01.03.01.05 0 .01.01.03.01.04 0 .01 0 .01.01.02 0 .01.01.02.02.03.01.01.01.03.02.04.01.02.02.03.03.05.01.01.02.02.02.03.01.01.02.03.04.04l.02.02 10 10c0 .01.91-.91.91-.91L2.2 11.1h25.86V9.81z"/></svg>
                </button>
                <button type="button" className="c-slider-nav__btn c-slider-nav__btn--next | js-next" aria-label="Next">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.06 20.91"><path d="M0 11.1h25.86L16.97 20c0 .04.91.92.91.91l10-10c0-.01.01-.01.02-.02l.04-.04c.01-.01.02-.02.02-.03.01-.01.02-.03.03-.05.01-.01.01-.03.02-.04 0-.01.01-.02.01-.03v-.02c.01-.01.01-.03.01-.04 0-.02.01-.03.01-.05 0-.01 0-.03.01-.04 0-.02 0-.03.01-.05v-.05-.05c0-.02 0-.03-.01-.05 0-.01 0-.03-.01-.04 0-.02-.01-.03-.01-.05 0-.01-.01-.03-.01-.04 0-.01 0-.01-.01-.02 0-.01-.01-.02-.02-.03-.01-.01-.01-.03-.02-.04-.01-.02-.02-.03-.03-.05-.01-.01-.02-.02-.02-.03-.01-.01-.02-.03-.04-.04.01 0 0-.01 0-.01l-10-10c0-.01-.91.91-.91.91l8.89 8.9H0v1.29z"/></svg>
                </button>
              </nav>
            </div>

            <div className="c-slider | js-drag-area">
              <div className="c-slider__slides" data-scroll="slideRight" data-tl-immediate>


                  <div className="c-slide | js-slide" style={{left: "0%"}}>
                    <div className="c-slide-item c-slide-item--1 o-cover">
                      <img src="/imager/images/912/gold_lifes_carosuel_background-copy_aa93d8ee9a3cc573b9a01b328410e8b2.jpg" alt="" draggable="false" className="js-drag-item" data-ease="a" />
                    </div>
                    <div className="c-slide-item c-slide-item--2 o-cover">
                      <img src="/images/golf.jpg" alt="" draggable="false" className="js-drag-item" data-ease="b" />
                    </div>
                    <div className="c-slide-item c-slide-item--3">
                      <div className="c-slide-item__content u-bg-white | js-drag-item" data-ease="c">
                        <div className="c-content c-content--min-s@sm c-content--max-s@sm">
                          <h3 className="o-h5 c-content__title c-content__title--small">Golf</h3>
                          <div className="c-content__text o-txt">
                            <p>
                              A world class Golf Course nearby
                            </p>
                          </div>

                                                  <a href="https://ancasterhamiltonhomes.com/experiences" className="c-slide__btn c-btn">
                              <div className="c-btn__borders">
                                <span className="c-btn__border c-btn__border--top"></span>
                                <span className="c-btn__border c-btn__border--bottom"></span>
                                <span className="c-btn__border c-btn__border--left"></span>
                                <span className="c-btn__border c-btn__border--right"></span>
                              </div>
                              <div className="c-btn__text c-btn__text--top">Explore</div>
                              <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Explore</div>
                            </a>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="c-slide | js-slide" style={{left: "100%"}}>
                    <div className="c-slide-item c-slide-item--1 o-cover">
                      <img src="/imager/images/665/photo-1478033394151-c931d5a4bdd6_aa93d8ee9a3cc573b9a01b328410e8b2.jpg" alt="" draggable="false" className="js-drag-item" data-ease="a" />
                    </div>
                    <div className="c-slide-item c-slide-item--2 o-cover">
                      <img src="https://dp92u1r0kzfby.cloudfront.net/falls_two.jpg" alt="" draggable="false" className="js-drag-item" data-ease="b" />
                    </div>
                    <div className="c-slide-item c-slide-item--3">
                      <div className="c-slide-item__content u-bg-white | js-drag-item" data-ease="c">
                        <div className="c-content c-content--min-s@sm c-content--max-s@sm">
                          <h3 className="o-h5 c-content__title c-content__title--small">Lifestyle</h3>
                          <div className="c-content__text o-txt">
                            <p>
                              Enjoy the charming, slower pace of life in the Ancaster <em className="small-text">and</em> Hamilton
                            </p>
                          </div>

                                                  <a href="https://ancasterhamiltonhomes.com/experiences" className="c-slide__btn c-btn">
                              <div className="c-btn__borders">
                                <span className="c-btn__border c-btn__border--top"></span>
                                <span className="c-btn__border c-btn__border--bottom"></span>
                                <span className="c-btn__border c-btn__border--left"></span>
                                <span className="c-btn__border c-btn__border--right"></span>
                              </div>
                              <div className="c-btn__text c-btn__text--top">Explore</div>
                              <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Explore</div>
                            </a>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="c-slide | js-slide" style={{left: "200%"}}>
                    <div className="c-slide-item c-slide-item--1 o-cover">
                      <img src="/imager/images/822/agriculture-countryside-crop-cropland-388415-copy_aa93d8ee9a3cc573b9a01b328410e8b2.jpg" alt="" draggable="false" className="js-drag-item" data-ease="a" />
                    </div>
                    <div className="c-slide-item c-slide-item--2 o-cover">
                      <img src="https://dp92u1r0kzfby.cloudfront.net/house.jpg" alt="" draggable="false" className="js-drag-item" data-ease="b" />
                    </div>
                    <div className="c-slide-item c-slide-item--3">
                      <div className="c-slide-item__content u-bg-white | js-drag-item" data-ease="c">
                        <div className="c-content c-content--min-s@sm c-content--max-s@sm">
                          <h3 className="o-h5 c-content__title c-content__title--small">What to do here</h3>
                          <div className="c-content__text o-txt">
                            <p>
                              Enjoy the great outdoors and the big city life all in one.
                            </p>
                          </div>

                                                  <a href="https://ancasterhamiltonhomes.com/experiences" className="c-slide__btn c-btn">
                              <div className="c-btn__borders">
                                <span className="c-btn__border c-btn__border--top"></span>
                                <span className="c-btn__border c-btn__border--bottom"></span>
                                <span className="c-btn__border c-btn__border--left"></span>
                                <span className="c-btn__border c-btn__border--right"></span>
                              </div>
                              <div className="c-btn__text c-btn__text--top">Explore</div>
                              <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Explore</div>
                            </a>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="c-slide | js-slide" style={{left: "300%"}}>
                    <div className="c-slide-item c-slide-item--1 o-cover">
                      <img src="/imager/images/3018/baked-pizza-on-pizza-peel-in-oven-905847_aa93d8ee9a3cc573b9a01b328410e8b2.jpg" alt="" draggable="false" className="js-drag-item" data-ease="a" />
                    </div>
                    <div className="c-slide-item c-slide-item--2 o-cover">
                      <img src="https://dp92u1r0kzfby.cloudfront.net/ham_dt_two.jpg" alt="" draggable="false" className="js-drag-item" data-ease="b" />
                    </div>
                    <div className="c-slide-item c-slide-item--3">
                      <div className="c-slide-item__content u-bg-white | js-drag-item" data-ease="c">
                        <div className="c-content c-content--min-s@sm c-content--max-s@sm">
                          <h3 className="o-h5 c-content__title c-content__title--small">Cuisine</h3>
                          <div className="c-content__text o-txt">
                            <p>
                              Explore the sights and sounds of this great city.
                            </p>
                          </div>

                                                  <a href="https://ancasterhamiltonhomes.com/experiences" className="c-slide__btn c-btn">
                              <div className="c-btn__borders">
                                <span className="c-btn__border c-btn__border--top"></span>
                                <span className="c-btn__border c-btn__border--bottom"></span>
                                <span className="c-btn__border c-btn__border--left"></span>
                                <span className="c-btn__border c-btn__border--right"></span>
                              </div>
                              <div className="c-btn__text c-btn__text--top">Explore</div>
                              <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Explore</div>
                            </a>

                        </div>
                      </div>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </div>
          <footer className="c-site-foot">
      <div className="c-site-foot__logo">
        <img src="/static/logo-standing.png" alt="Chileno bay club" />
      </div>
      <div className="c-site-foot__inner o-padding-top-xs o-padding-bottom-xxs">
        <div className="c-site-foot__contact">
          <h3 className="c-site-foot__title">Contact us</h3>
          <ul className="c-site-foot__contact-list">
            <li className="c-site-foot__contact-item">
              <a href="tel:9055126900">
                <span>T:</span>
                <span>(905) 512-6900</span>
              </a>
            </li>
            <li className="c-site-foot__contact-item">
              <a href="mailto:mrusso@sutton.com">
                <span>E:</span>
                <span>mrusso@sutton.com</span>
              </a>
            </li>
            <li className="c-site-foot__contact-item">
              <a href="https://www.facebook.com/Michael-Russo-Homes-107597214304424/" target="_blank" rel="noreferrer">
                <span>
                  <svg className="o-icon icon-facebook">
                    <use></use>
                  </svg>
                </span>
                <span>Facebook</span>
              </a>
            </li>
          </ul>
        </div>
        <nav className="c-site-foot__menu">
          <ul className="c-site-foot__menu-top">
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/experiences">Experiences</a>
            </li>
            <li>
              <a href="/listings">Listings</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
          <ul className="c-site-foot__menu-sub">
            <li>
              <a href="/press"></a>
            </li>
            <li>
              <a href="/terms">Privacy</a>
            </li>
          </ul>
        </nav>
        <div className="c-site-foot__bottom">
          <p className="c-site-foot__copyright">
            <a href="https://prosession.me" target="_blank">2020 Prosession.me</a> <br /> Video provided by <a href="https://www.youtube.com/watch?v=27eaYPrXA8M&t=11s" target="_blank">Joel Guerin</a>
          </p>
          <a className="c-site-foot__dlc" href="https://ancasterhamiltonhomes.com" target="_blank" rel="noreferrer">

          </a>
        </div>
      </div>
    </footer>    </div>
      </article>
    </main>

    <div className="c-fixed">
      <div className="c-mask | js-mask"></div>
      <div className="c-orientation">
        <p>Please rotate your device or refresh page</p>
      </div>
      <div className="c-consent o-gutter | js-consent">
        <div className="o-row">
          <div className="c-consent__inner">
            <p>
    We use cookies in accordance with our Cookie Notice. Please refer to our Cookie Notice <a href="/terms">here</a> for more information on how we use cookies and how to adjust your browser settings to block cookies. If you consent to the use of cookies, please click Accept. We will not ask for consent for strictly necessary cookies, but if you choose to block strictly necessary cookies this may affect your website experience.
            </p>
            <div className="c-consent__btn">
              <button type="button" className="c-btn | js-consent__ok">
                <div className="c-btn__borders">
                  <span className="c-btn__border c-btn__border--top"></span>
                  <span className="c-btn__border c-btn__border--bottom"></span>
                  <span className="c-btn__border c-btn__border--left"></span>
                  <span className="c-btn__border c-btn__border--right"></span>
                </div>
                <div className="c-btn__text c-btn__text--top">Accept</div>
                <div className="c-btn__text c-btn__text--bottom" aria-hidden="true">Accept</div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="c-fixed__pe | js-pe"></div>
    </div>
    </div>
  );
}

export default App;
